import { useState, useEffect, useCallback } from 'react';
import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import { db } from '../firebase';

export function useAcademicYear(externalYear = null, schoolId = null) {
  const [academicYears, setAcademicYears] = useState([]);
  const [selectedYear, setSelectedYear] = useState(externalYear);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (externalYear) {
      setSelectedYear(externalYear);
    }
  }, [externalYear]);

  const loadAcademicYears = useCallback(async () => {
    try {
      setLoading(true);
      // Load all years, then keep the school's own years plus global records
      // (missing/null schoolId) which Super Admin manages for everyone.
      const q = query(collection(db, 'academicYears'), orderBy('startDate', 'desc'));
      const snapshot = await getDocs(q);
      const years = snapshot.docs
        .map(doc => ({ id: doc.id, ...doc.data() }))
        .filter(y => !schoolId || !y.schoolId || y.schoolId === schoolId);
      setAcademicYears(years);
      if (!selectedYear && !externalYear) {
        const active = years.find(y => y.isActive) || years[0] || null;
        setSelectedYear(active);
      }
    } catch (error) {
      console.error('Error loading academic years:', error);
    } finally {
      setLoading(false);
    }
  }, [schoolId, externalYear, selectedYear]);

  useEffect(() => {
    loadAcademicYears();
  }, [loadAcademicYears]);

  return {
    academicYears,
    selectedYear,
    setSelectedYear,
    loading
  };
}
